import { FC } from "react";
import { LP_BORDER, LP_TEXT } from "./legalProtectionTheme";

interface LegalProtectionEmptyCardProps {
  /** What is missing, in one line. */
  text: string;
  /** Section greyed out: dashed outline and text in the disabled grey. */
  disabled?: boolean;
}

/**
 * Empty state of a legal protection section: a dashed card, so an empty section never reads
 * like a filled one.
 */
export const LegalProtectionEmptyCard: FC<LegalProtectionEmptyCardProps> = ({ text, disabled }) => (
  <div
    className={`flex w-full flex-col items-center gap-4 rounded-xl border border-dashed bg-white px-8 py-10 ${disabled ? LP_BORDER.emptyDisabled : LP_BORDER.empty}`}
  >
    <p className={`text-[16px] font-bold ${disabled ? LP_TEXT.disabled : LP_TEXT.title}`}>{text}</p>
  </div>
);
